import { Navigate, Outlet } from "react-router-dom";
import { useContext } from "react";
import { usecontextUser } from "../../context/usecontextUser";


const ProtectedRoute = ({ allowedRoles }) => {
  const { user } =useContext(usecontextUser); 
  const userId =localStorage.getItem("userId")
  const token =localStorage.getItem("token")
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (!userId) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
